import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../styles/login.css";
import logo from "../assets/naxora-logo.png";

const Login = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const loginFromApi = async (email, password) => {
    const endpoint = "https://growrise.shop/api/auth/login";

    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 20000);

    let response;
    let data;

    try {
      response = await fetch(endpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ email, password }),
        signal: controller.signal,
      });
    } catch (error) {
      if (error.name === "AbortError") {
        throw new Error("Server is taking too long to respond. Please try again.");
      }

      throw new Error("Connection failed. Please check your internet or try again in a few moments.");
    } finally {
      clearTimeout(timeoutId);
    }

    const responseText = await response.text();

    try {
      data = responseText ? JSON.parse(responseText) : {};
    } catch (error) {
      throw new Error("Invalid server response. Please contact support.");
    }

    if (!response.ok) {
      throw new Error(data.message || "Login failed");
    }

    const userData = data.user || data.data || data;
    const token = data.token || data.accessToken || "";

    localStorage.setItem("growriseAuth", "true");
    localStorage.setItem("growriseCurrentUser", JSON.stringify(userData));

    localStorage.setItem("naxoraAuth", "true");
    localStorage.setItem("isAuthenticated", "true");
    localStorage.setItem("naxoraCurrentUser", JSON.stringify(userData));
    localStorage.setItem("currentUser", JSON.stringify(userData));

    if (token) {
      localStorage.setItem("growriseToken", token);
      localStorage.setItem("token", token);
      localStorage.setItem("naxoraToken", token);
    }

    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const enteredEmail = formData.email.trim().toLowerCase();
    const enteredPassword = formData.password.trim();

    if (!enteredEmail || !enteredPassword) {
      alert("Please enter both email and password.");
      return;
    }

    setLoading(true);

    try {
      await loginFromApi(enteredEmail, enteredPassword);
      navigate("/dashboard");
    } catch (error) {
      console.error("Login error:", error);
      alert(error.message || "Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-overlay"></div>

      <div className="login-container">
        <div className="login-brand">
          <img src={logo} alt="NAXORA Logo" className="login-logo" />
          <p>Premium Digital Platform</p>
        </div>

        <div className="login-card">
          <div className="login-card-top">
            <h2>Welcome Back</h2>
            <p>Login to your secure account</p>
          </div>

          <form onSubmit={handleSubmit} className="login-form">
            <div className="input-group">
              <label>Email Address</label>
              <input
                type="email"
                name="email"
                placeholder="Enter your email"
                value={formData.email}
                onChange={handleChange}
              />
            </div>

            <div className="input-group">
              <label>Password</label>

              <div className="password-wrapper">
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  placeholder="Enter your password"
                  value={formData.password}
                  onChange={handleChange}
                />

                <button
                  type="button"
                  className="show-password-btn"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? "Hide" : "Show"}
                </button>
              </div>
            </div>

            <div className="login-options">
              <label className="remember-me">
                <input type="checkbox" />
                <span>Remember me</span>
              </label>

              <Link to="/forgot-password" className="forgot-link">
                Forgot Password?
              </Link>
            </div>

            <button type="submit" className="login-btn" disabled={loading}>
              {loading ? "Signing In..." : "Login"}
            </button>
          </form>

          <div className="login-footer">
            <p>
              Don&apos;t have an account?{" "}
              <Link to="/register" className="register-link">
                Register
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;